import {
  ApproveImportedOrganizationValues,
  ImportedOrganization,
  RejectImportedOrganizationValues,
} from 'modules/importedOrganizations/types/importedOrganization';
import { HttpErrorResponse, HttpResponse, SuccessCallback } from 'types';
import { createAction, createAsyncAction, createCustomAction } from 'typesafe-actions';

export const getImportedOrganizations = createAction('IMPORTED_ORGANIZATION_GET');
export const getImportedOrganizationsRequest = createAsyncAction(
  'IMPORTED_ORGANIZATION_REQUEST',
  'IMPORTED_ORGANIZATION_SUCCESS',
  'IMPORTED_ORGANIZATION_REJECTED'
)<undefined, HttpResponse<ImportedOrganization>, HttpErrorResponse>();

export const approveImportedOrganization = createCustomAction(
  'IMPORTED_ORGANIZATION_APPROVE',
  (type) => (values: ApproveImportedOrganizationValues, successCallback?: SuccessCallback) => {
    return {
      payload: values,
      successCallback,
      type,
    };
  }
);
export const approveImportedOrganizationRequest = createAsyncAction(
  'IMPORTED_ORGANIZATION_APPROVE_REQUEST',
  'IMPORTED_ORGANIZATION_APPROVE_SUCCESS',
  'IMPORTED_ORGANIZATION_APPROVE_REJECTED'
)<undefined, ImportedOrganization | null, HttpErrorResponse>();

export const rejectImportedOrganization = createCustomAction(
  'IMPORTED_ORGANIZATION_REJECT',
  (type) => (values: RejectImportedOrganizationValues, successCallback?: SuccessCallback) => {
    return {
      payload: values,
      successCallback,
      type,
    };
  }
);
export const rejectImportedOrganizationRequest = createAsyncAction(
  'IMPORTED_ORGANIZATION_REJECT_REQUEST',
  'IMPORTED_ORGANIZATION_REJECT_SUCCESS',
  'IMPORTED_ORGANIZATION_REJECT_REJECTED'
)<undefined, ImportedOrganization | null, HttpErrorResponse>();
